import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { db, auth } from "../config/firebase";
import { doc, getDoc } from 'firebase/firestore';
import { useAuthState } from "react-firebase-hooks/auth";

interface Props {
    reservation,
    updateReservation,
    widgetSettings,
    widgetRules
}

const TeeTimeForm: React.FC<Props> = ({ reservation, updateReservation, widgetSettings, widgetRules }) => {
    const [allow18Holes, setAllow18Holes] = useState([]);
    const [allow9Holes, setAllow9Holes] = useState([]);
    const [requirePayment, setRequirePayment] = useState(false);
    const [bookingDenied, setBookingDenied] = useState(false);
    const [denyMessage, setDenyMessage] = useState('');
    const [user, loading] = useAuthState(auth);
    const groupID = localStorage.getItem('group');
    const courseID = localStorage.getItem('course');

    console.log('TeeTimeForm mounted with auth state:', {
        user: user ? 'exists' : 'null',
        loading,
        uid: user?.uid,
        groupID,
        courseID
    });

    // Add a simple effect to verify effects are working
    useEffect(() => {
        console.log('Simple effect triggered');
    }, []);

    useEffect(() => {
        console.log('Widget settings effect triggered');
        setAllow18Holes(widgetSettings?.allow18Holes);
        setAllow9Holes(widgetSettings?.allow9Holes);
        setRequirePayment(widgetSettings?.requirePayment);
        //eslint-disable-next-line
    }, [widgetSettings]);

    // Add effect to check user privileges
    useEffect(() => {
        console.log('=== Privilege Check Effect Start ===');
        console.log('Effect dependencies:', {
            user: user ? 'exists' : 'null',
            loading,
            uid: user?.uid,
            groupID,
            courseID
        });

        if (loading) {
            console.log('Auth state is still loading...');
            return;
        }

        if (!user?.uid || !groupID || !courseID) {
            console.log('Missing required IDs:', {
                userExists: !!user,
                loading,
                uid: user?.uid,
                groupID,
                courseID
            });
            return;
        }

        const checkUserPrivileges = async () => {
            try {
                console.log('Fetching user document for ID:', user.uid);
                const userDoc = await getDoc(doc(db, 'users', user.uid));
                if (!userDoc.exists()) {
                    console.log('User document does not exist');
                    return;
                }

                const userData = userDoc.data();
                console.log('User data:', userData);
                const privileges = userData.privileges || [];
                console.log('User privileges:', privileges);

                // Find privileges for this specific course
                const coursePrivilege = privileges.find(p => {
                    console.log('Checking privilege:', p);
                    return p.group === groupID && p.course === courseID;
                });
                console.log('Found course privilege:', coursePrivilege);

                if (coursePrivilege?.denyOnlineBooking === "true") {
                    console.log('Booking denied for this course');
                    setBookingDenied(true);
                    setDenyMessage(coursePrivilege.denyOnlineBookingMessage || 'Online booking is not available for this course.');
                } else {
                    console.log('Booking allowed for this course');
                    setBookingDenied(false);
                    setDenyMessage('');
                }
            } catch (error) {
                console.error('Error checking user privileges:', error);
            }
        };

        checkUserPrivileges();
        console.log('=== Privilege Check Effect End ===');
    }, [user, loading, groupID, courseID]);

    const getDaysArray = function (start, end) {
        var arr = [], dt = new Date(start);

        while (dt <= end) {
            arr.push(new Date(dt));
            dt.setDate(dt.getDate() + 1);
        }

        return arr;
    }

    //Get next 7 days
    const today = new Date();
    const todayPlus1 = new Date(today);
    todayPlus1.setDate(todayPlus1.getDate() + 1);
    const advanceDate = new Date(today);
    advanceDate.setDate(advanceDate.getDate() + widgetSettings?.daysInAdvance);
    const thisWeekList = getDaysArray(today, advanceDate);

    // useEffect(() => {

    //     console.log('Received: Reservation update in Tee Time Form: ', reservation);
    // }, [reservation]);

    return (
        <div id="chooseTime" className="p-3">
            {widgetSettings?.widgetMessage &&
                <div className="alert alert-warning text-center">{widgetSettings?.widgetMessage}</div>
            }
            {bookingDenied ? (
                <div className="alert alert-warning alert-outline mx-2 text-center">
                    <h4 className="alert-heading">Online Booking Denied</h4>
                    {denyMessage && <p>{denyMessage}</p>}
                </div>
            ) : (
                <>
                    <div className="form-text text-center mb-2">When would you like to play?</div>

                    <select className="form-select mb-3" aria-label="select time to play" value={reservation.date} data-reset-time="true" name="date" onChange={updateReservation}>
                        <option value="null">Choose a date</option>

                        {thisWeekList.map((day) =>
                            <option key={day} value={moment(day).format('YYYY-MM-DD')}>{moment(day).format('dddd, MMMM Do')}</option>
                        )}
                    </select>

                    {/* <!-- how  many players? --> */}
                    <div className="form-text text-center mb-2">How many players?</div>
                    <div className="btn-group equalWidth d-flex mb-3" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" checked={reservation.numPlayers === 1} className="btn-check" name="numPlayers" id="players1" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="1" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="players1">1</label>

                        <input type="radio" checked={reservation.numPlayers === 2} className="btn-check" name="numPlayers" id="players2" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="2" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="players2">2</label>

                        <input type="radio" checked={reservation.numPlayers === 3} className="btn-check" name="numPlayers" id="players3" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="3" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="players3">3</label>

                        <input type="radio" checked={reservation.numPlayers === 4} className="btn-check" name="numPlayers" id="players4" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="4" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="players4">4</label>
                    </div>

                    {/* <!-- how  many cart seats? --> */}
                    {/* <div className="form-text text-center mb-2">How many cart seats? ($7 per player)</div>
                    <div className="btn-group equalWidth d-flex mb-3" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" className="btn-check" name="numCarts" id="carts0" autoComplete="off" data-radio-value="0" data-type="integer" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="carts0">0</label>

                        <input type="radio" className="btn-check" name="numCarts" id="carts1" autoComplete="off" data-radio-value="1" data-type="integer" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="carts1">1</label>

                        <input type="radio" className="btn-check" name="numCarts" id="carts2" autoComplete="off" data-radio-value="2" data-type="integer" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="carts2">2</label>

                        <input type="radio" className="btn-check" name="numCarts" id="carts3" autoComplete="off" data-radio-value="3" data-type="integer" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="carts3">3</label>

                        <input type="radio" className="btn-check" name="numCarts" id="carts4" autoComplete="off" data-radio-value="4" data-type="integer" onChange={updateReservation}></input>
                        <label className="btn btn-outline-primary" htmlFor="carts4">4</label>
                    </div> */}

                    {/* <!-- Number of holes --> */}
                    <div className="form-text text-center mb-2">How many holes?</div>
                    <div className="btn-group equalWidth d-flex mb-3" role="group" aria-label="Basic radio toggle button group">
                        {/* <input type="radio" checked={reservation?.numHoles === 9} className="btn-check" name="numHoles" id="holes9" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="9" onChange={updateReservation} disabled={allow9Holes?.length === 0 ? true : false}></input>
                        <label  className={allow9Holes?.length === 0 ? "btn btn-outline-primary disabled-input" : "btn btn-outline-primary"} htmlFor="holes9">9</label>

                        <input type="radio" checked={reservation?.numHoles === 18} className="btn-check" name="numHoles" id="holes18" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="18" onChange={updateReservation} disabled={allow18Holes?.length === 0 ? true : false}></input>
                        <label className={allow18Holes?.length === 0 ? "btn btn-outline-primary disabled-input" : "btn btn-outline-primary"} htmlFor="holes18">18</label> */}

                        <input type="radio" checked={reservation?.numHoles === 9} className="btn-check" name="numHoles" id="holes9" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="9" onChange={updateReservation} ></input>
                        <label className="btn btn-outline-primary" htmlFor="holes9">9</label>

                        <input type="radio" checked={reservation?.numHoles === 18} className="btn-check" name="numHoles" id="holes18" autoComplete="off" data-reset-time="true" data-type="integer" data-radio-value="18" onChange={updateReservation} ></input>
                        <label className="btn btn-outline-primary" htmlFor="holes18">18</label>
                    </div>
                </>
            )}
        </div>
    )
}

export default TeeTimeForm